import { Component, ElementRef, Input, NgZone, ViewChild, OnDestroy } from '@angular/core';
import { Chart, registerables } from 'chart.js/auto';
import 'chartjs-plugin-datalabels';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { DaterangepickerConfig } from 'ng2-daterangepicker';
import { MainDepartment, Stores } from '../../../../Models/ApplicationModels';
import { BreadcrumbService } from '../../../../Services/breadcrumb.service';
import { MasterDataSeriveService } from '../../../../Services/master-data-serive.service';

declare global {
  interface JQuery {
    daterangepicker(options?: any, callback?: any): any;
  }
}

declare var $: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnDestroy {
  @ViewChild('platform') platform!: ElementRef;
  @ViewChild('price') price!: ElementRef;
  // ViewChild references for canvas elements
  @ViewChild('categoryCanvas') categoryCanvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('employeeCanvas') employeeCanvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('brandCanvas') brandCanvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('platformdeptCanvas') platformdeptCanvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('printCanvas') printCanvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('priceCanvas') priceCanvas!: ElementRef<HTMLCanvasElement>;
  defaultStore: number = 0;
  defaultDept: number = 0;
  mainDepartmentList: Array<MainDepartment> = [];
  private charts: Chart[] = [];
  dashboardDepartment: any;
  label: any;
  data: any;
  platformChart: any;
  priceChart: any;
  deptName: string = 'All Departments';
  deptNames: Array<string> = []
  barChartData: Array<any> = [];
  barChartLabels: Array<any> = [];
  deptQty: number = 0;
  empQty: number = 0;
  brandQty: number = 0;
  formatQty: number = 0;
  specialPriceQty: number = 0;
  platformQty: number = 0;
  isLoading: boolean = false;
  platformDepartmentQty: number = 0;
  totalQty: number = 0;
  totalPrice: number = 0;
  totalCatg: number = 0;
  printLabels: any;
  platformData: Array<any> = [];
  platformLabels: any;
  platformDeptLabels: any;
  startDate: any = null;
  endDate: any = null;
  range = new FormGroup({
    start: new FormControl<Date | null>(null, [Validators.required, this.dateValidator]),
    end: new FormControl<Date | null>(null, [Validators.required, this.dateValidator]),
  });
  departmentCategoryLbl: any;
  @ViewChild('dateRange') dateRange!: ElementRef<HTMLElement>;
  @Input() max: any;
  maxDate = new Date();
  public daterange: any = {};
  stores: Array<Stores> = [];
  employees: Array<any> = [];
  tableData: Array<any> = [];
  dashboardTabledata: any = [];
  StoreNames: string | any = [];
  tableDataTotalQty: number = 0;
  departmentId: number = 0;
  isNoDataFound: boolean = false;
  isTableData: boolean = false;
  categoryData: boolean = true;
  employeeData: boolean = true;
  brandData: boolean = true;
  printData: boolean = true;
  specialPriceData: boolean = true;
  platformsData: boolean = true;
  platformDeptData: boolean = true;
  tempToggleOption: number = 1;
  reportHasRun: boolean = false;
  constructor(private datepipe: DatePipe, private daterangepickerOptions: DaterangepickerConfig, private zone: NgZone, private elementRef: ElementRef, private fb: FormBuilder, private datePipe: DatePipe, private breadcrumbService: BreadcrumbService, private masterservice: MasterDataSeriveService) {
    this.maxDate.setDate(this.maxDate.getDate());
  }

  async ngOnInit() {

    this.startDate = moment().startOf("day"); // Today 12:00 AM
    this.endDate = moment().endOf("day"); // Today 11:59:59 PM
    this.breadcrumbService.updateActiveDeptTab('Dashboard');
    this.breadcrumbService.updateActiveCategoryTab('Production Overview');
    this.getStores();
    this.getMainDepartments();
    // Do NOT auto-fetch report data on init. The user must click Run Report.
  }

  runReport() {
    this.reportHasRun = true;
    this.updateChart(this.defaultDept);
  }

  calculateTotalQty(row: any): number {
    return row.qty.reduce((total: any, qty: any) => total + qty, 0);
  }
  calculateRowTotal(row: any): number {
    const rowTotal = row.reduce((total: any, qty: any) => total + qty.qty, 0);
    return rowTotal;
  }
  calculateColumnTotal(store: string): number {
    let storeData;
    const total = this.dashboardTabledata.reduce((total: any, dashboardTabledata: { qty: any[]; }) => {
      if (true) {
        storeData = dashboardTabledata.qty.find((item: any) => item.userName === store);
      } else {
        storeData = dashboardTabledata.qty.find((item: any) => item.store === store);
      }
      const storeQty = storeData ? storeData.qty : 0;
      return total + storeQty;
    }, 0);
    return total;
  }

  getDashboardTable() {
    if (!this.reportHasRun) return;
    this.isLoading = true;
    let formattedStartDate: any = this.datepipe.transform(this.startDate, 'yyyy-MM-dd HH:mm:ss');
    let formattedEndDate: any = this.datepipe.transform(this.endDate, 'yyyy-MM-dd HH:mm:ss');
    if (!formattedStartDate) {
      formattedStartDate = null;
    }
    if (!formattedEndDate) {
      formattedEndDate = null;
    }
    let user = this.masterservice.getUserDetailsFromStorage();
    this.masterservice.getDashboardTable(user.companyID, this.defaultDept, formattedStartDate, formattedEndDate).subscribe(
      {
        next: (res: any) => {

          let result = res as any[];
          const storeNamesSet = new Set<string>();
          this.StoreNames = [];
          if (res.length > 0) {
            res.forEach((item: { userName: string; }) => {
              storeNamesSet.add(item.userName);
            })
          }
          this.StoreNames = Array.from(storeNamesSet);
          this.dashboardTabledata = this.formateDashboardTableData(res);
          this.tableDataTotalQty = this.dashboardTabledata.reduce((sum: any, dep: { qty: any[]; }) => sum + dep.qty.reduce((total, q) => total + q.qty, 0), 0);
          this.isLoading = false;
        }
      }

    )
  }

  getDeptUserWiseQty(deptData: any, user: string): number {
    let storeData;
    storeData = deptData.qty.find((item: any) => item.userName === user);
    return storeData ? storeData.qty : 0;
  }

  getEmployees(data: any): Array<any>[] {

    return data.reduce((acc: any[], item: { userID: any; userName: any; }) => {
      let employee = this.employees.find(e => e.employeeID === item.userID);
      if (!employee) {
        employee = {
          employeeID: item.userID,
          employeeName: item.userName,
        };
        this.employees.push(employee)
      }
    })
  }

  /*toggleTableOrGraph() {
    this.isTableData = !this.isTableData;
  }*/

  toggleTableOrGraph(value: number) {
    if (this.tempToggleOption !== value) {
      this.tempToggleOption = value;
      this.isTableData = value !== 1;
      // Switching the view must not auto-fetch. The user must click Run Report
      // to load data for the newly selected view.
    }
  }

  public options: any = {
    locale: {
      format: 'MM/DD/YYYY',
      separator: ' - ',
      applyLabel: 'Apply',
      cancelLabel: 'Cancel'
    },
    alwaysShowCalendars: true,
    showDropdowns: false,
    showCustomRangeLabel: true,
    maxDate: new Date(),
    ranges: {
      'Today': [moment(), moment()],
      'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      'Last 7 Days': [moment().subtract(6, 'days'), moment()],
      'This Month': [moment().startOf('month'), moment().endOf('month')],
    },
    opens: "left"
  };

  public selectedDate(value: any, datepicker?: any) {
    this.endDate = value.end._d;
    this.startDate = value.start._d;
    datepicker.start = value.start;
    datepicker.end = value.end;
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    this.daterange.label = value.label;
  }

  openCalender() {
    if (this.dateRange) {
      this.dateRange.nativeElement.click();
    }
  }

  dateValidator(control: any) {
    const selectedDate = control.value;
    const today = new Date();

    if (selectedDate && selectedDate >= today) {
      return null;
    } else {
      return { invalidDate: true };
    }
  }

  getStores() {
    let store = localStorage.getItem('storeId')!;
    this.defaultStore = parseInt(store);
    let user = this.masterservice.getUserDetailsFromStorage();
    this.masterservice.getallstores(user.companyID).subscribe((res) => {
      this.stores = res as Stores[];
    })
  }

  selectCurrentDay() {
    this.startDate = new Date();
    this.endDate = new Date();
  }

  selectCurrentWeek() {
    const today = new Date();
    const startOfWeek = moment(today).startOf('week').toDate();
    const endOfWeek = moment(today).endOf('week').toDate();
    this.startDate = startOfWeek;
    this.endDate = endOfWeek;
  }

  selectCurrentMonth() {
    const today = new Date();
    const startOfMonth = moment(today).startOf('month').toDate();
    const endOfMonth = moment(today).endOf('month').toDate();
    this.startDate = startOfMonth;
    this.endDate = endOfMonth;
  }

  getMainDepartments() {

    this.masterservice.getDepartmentsProduction(false, 0).subscribe(
      (Response: any) => {
        this.mainDepartmentList = Response as MainDepartment[];
      },
      (err) => { }
    );
  }

  /*set custom filter names*/

  selectAllDepartments() {
    this.deptName = 'All Departments';
    this.defaultDept = 0;
  }

  setFilterNames(filterObj: any, option: number) {
    if (option === 2) {
      this.deptName = filterObj.departmentDescr;
      this.defaultDept = filterObj.departmentId;
    }
  }

  async getDashboardDepartment(departmentId: number) {
    if (!this.reportHasRun) return;
    this.isLoading = true
    let formattedStartDate: any = this.datepipe.transform(this.startDate, 'yyyy-MM-dd HH:mm:ss');
    let formattedEndDate: any = this.datepipe.transform(this.endDate, 'yyyy-MM-dd HH:mm:ss');
    if (!formattedStartDate) {
      formattedStartDate = null;
    }
    if (!formattedEndDate) {
      formattedEndDate = null;
    }
    let user = this.masterservice.getUserDetailsFromStorage();
    await this.masterservice.getDashboardDepartment(user.companyID, this.defaultDept, formattedStartDate, formattedEndDate).subscribe(
      {
        next: (res) => {

          this.dashboardDepartment = res as any[];
          this.dashboardDepartment.stats.forEach((res: any) => {
            this.totalPrice = res.price;
            this.totalQty = res.qty;
            this.totalCatg = res.categoryCnt;
          })
          this.dashboardDepartment.department.map((res: any) => {
            this.deptQty += res.qty;
          })

          this.dashboardDepartment.emp.map((res: any) => {
            this.empQty += res.qty;
            if (!res.userName) {
              res.userName = '-';
            }
          })

          this.dashboardDepartment.brand.map((res: any) => {
            this.brandQty += res.qty;
          })

          this.dashboardDepartment.format.map((res: any) => {
            this.formatQty += res.qty;
          })

          this.dashboardDepartment.specialPrice.map((res: any) => {
            this.specialPriceQty += res.qty;
          })

          this.dashboardDepartment.platform.map((res: any) => {
            this.platformQty += res.qty;
          })

          this.dashboardDepartment.platformDepartment.map((res: any) => {
            this.platformDepartmentQty += res.qty;
          })

          this.categoryData = this.dashboardDepartment.department.length == 0 ? false : true;
          this.employeeData = this.dashboardDepartment.emp.length === 0 ? false : true;
          this.brandData = this.dashboardDepartment.brand.length === 0 ? false : true;
          this.printData = this.dashboardDepartment.format.length === 0 ? false : true;
          this.specialPriceData = this.dashboardDepartment.specialPrice.length === 0 ? false : true;
          this.platformsData = this.dashboardDepartment.platform.length === 0 ? false : true;
          this.platformDeptData = this.dashboardDepartment.platformDepartment.length === 0 ? false : true;

          let uniquePlatform: Array<any> = [];
          let platformTypes: Array<any> = [];

          this.dashboardDepartment.platformDepartment.forEach((item: { categoryId: any; departmentDescr: any; }) => {
            const existingPlatform = uniquePlatform.find(dep => dep.departmentId === item.categoryId);
            if (!existingPlatform) {
              uniquePlatform.push({
                departmentId: item.categoryId,
                departmentDescr: item.departmentDescr
              })
            }
          });
          this.dashboardDepartment.platformDepartment.forEach((item: { locationId: any; location: any; }) => {
            const isPlatform = platformTypes.find(res => res.locationId === item.locationId);
            if (!isPlatform) {
              platformTypes.push({
                location: item.location,
                locationId: item.locationId
              })
            }
          });
          this.platformLabels = uniquePlatform;
          this.platformDeptLabels = platformTypes;
          for (let i: number = 0; i < platformTypes.length; i++) {
            for (let j: number = 0; j < uniquePlatform.length; j++) {
              let qtyValue = 0;

              this.dashboardDepartment.platformDepartment.forEach((res: { locationId: any; categoryId: any; qty: any; }) => {
                if (res.locationId == platformTypes[i].locationId && res.categoryId == uniquePlatform[j].departmentId) {
                  qtyValue = res.qty;
                }
              });

              if (!this.platformData[i]) {
                this.platformData[i] = [];
              }

              this.platformData[i][j] = qtyValue;
            }
          }

          let uniqueDepartments: Array<any> = [];
          let formatTypes: Array<any> = [];

          this.dashboardDepartment.format.forEach((item: { departmentId: any; departmentDescr: any; }) => {
            const existingDepartment = uniqueDepartments.find(dep => dep.departmentId === item.departmentId);

            if (!existingDepartment) {
              uniqueDepartments.push({
                departmentId: item.departmentId,
                departmentDescr: item.departmentDescr,
              });
            }
          });

          this.dashboardDepartment.format.forEach((item: { formatTypeId: any; formatTypeDesr: any; }) => {
            const existingDepartment = formatTypes.find(dep => dep.formatTypeId === item.formatTypeId);
            if (!existingDepartment) {
              formatTypes.push({
                formatTypeId: item.formatTypeId,
                formatTypeDesr: item.formatTypeDesr
              });
            }
          });

          this.barChartLabels = uniqueDepartments;
          if (formatTypes.length == 2) {
            formatTypes.push({
              formatTypeId: 17,
              formatTypeDesr: 'No Label or Tag'
            });
          }
          this.printLabels = formatTypes;

          for (let i: number = 0; i < formatTypes.length; i++) {
            for (let j: number = 0; j < uniqueDepartments.length; j++) {
              let qtyValue = 0;

              this.dashboardDepartment.format.forEach((res: { formatTypeId: any; departmentId: any; qty: any; }) => {
                if (res.formatTypeId == formatTypes[i].formatTypeId && res.departmentId == uniqueDepartments[j].departmentId) {
                  qtyValue = res.qty;
                }
              });

              if (!this.barChartData[i]) {
                this.barChartData[i] = [];
              }

              this.barChartData[i][j] = qtyValue;
            }
          }


          this.departmentCategoryLbl = this.transformData(this.dashboardDepartment.deptCatg)
          this.departmentCategoryLbl.map((res: { qty: any; departmentId: any; }) => {
            this.dashboardDepartment.department.forEach((result: { qty: any; departmentId: any; }) => {
              if (res.departmentId == result.departmentId) {
                res.qty = result.qty
              }
            })
          })

          setTimeout(() => {
            this.renderChart();
          }, 100);
          this.isLoading = false;
        }
      }

    )
  }

  transformData(originalData: any[]) {
    this.isLoading = true
    const transformedData: { departmentId: any; qty: any, data: { categoryId: any; categoryName: any; qty: any; }[]; }[] = [];
    originalData.forEach(item => {
      const departmentId = item.departmentId;
      const categoryId = item.categoryId;
      const categoryName = item.categoryName;
      const qty = item.qty;
      const existingDepartment = transformedData.find(d => d.departmentId === departmentId);

      if (existingDepartment) {
        existingDepartment.data.push({
          categoryId,
          categoryName,
          qty
        });
      } else {
        transformedData.push({
          departmentId,
          qty,
          data: [{
            categoryId,
            categoryName,
            qty
          }]
        });
      }
    });
    this.isLoading = false
    return transformedData
  }

  renderChart() {
    this.isLoading = true;
    Chart.register(...registerables);
    Chart.register(ChartDataLabels);
    if (this.categoryData) {
      const _catEl = this.categoryCanvas && this.categoryCanvas.nativeElement ? this.categoryCanvas.nativeElement as HTMLCanvasElement : null;
      if (_catEl) {
        const _existing = Chart.getChart(_catEl as any);
        if (_existing) {
          try { _existing.destroy(); } catch (e) { console.warn('Error destroying existing category chart', e); }
          const _i = this.charts.indexOf(_existing as any);
          if (_i > -1) { this.charts.splice(_i, 1); }
        }
        let category = new Chart(_catEl, {
        type: 'bar',
        data: {
          labels: this.dashboardDepartment.department.map((item: any) => item.departmentDescr),
          datasets: [{
            label: 'Department and Categories',
            barThickness: 25,
            data: this.dashboardDepartment.department.map((item: any) => item.qty),
            backgroundColor: ['#95A4FC'],
            borderRadius: 8,
            borderSkipped: false
          }]
        },
        options: {
          plugins: {
            tooltip: {
              callbacks: {
                label: (context) => {
                }
              }
            },
            legend: {
              display: false,
              position: 'top',
              labels: {
                usePointStyle: true,
              },
            },
            datalabels: {
              display: false,
              color: '#000',
              font: {
                size: 12,
                weight: "bold"
              },
              anchor: "end",
              align: "start",
              offset: -23
            },
          },
          layout
            : {
            padding: {
              bottom: 40
            }
          },

          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: false,
                text: 'No. of Items'
              },
              border: {
                display: false,
              },
            },
            x: {
              beginAtZero: true,
              title: {
                display: false,
                text: 'Departments'
              },
              border: {
                display: false,
              },
              grid: {
                display: false,
              }
            }
          },
          responsive: true,
          maintainAspectRatio: false
        }
      });
        this.charts.push(category);
      } else {
        console.warn('Canvas element not found: category');
      }
    }
    if (this.employeeData) {
      const _empEl = this.employeeCanvas && this.employeeCanvas.nativeElement ? this.employeeCanvas.nativeElement as HTMLCanvasElement : null;
      if (_empEl) {
        const _existing = Chart.getChart(_empEl as any);
        if (_existing) {
          try { _existing.destroy(); } catch (e) { console.warn('Error destroying existing employee chart', e); }
          const _i = this.charts.indexOf(_existing as any);
          if (_i > -1) { this.charts.splice(_i, 1); }
        }
        let employee = new Chart(_empEl, {
        type: 'bar',
        data: {
          labels: this.dashboardDepartment.emp.map((res: any) => res.userName),
          datasets: [{
            label: 'Employees',
            barThickness: 25,
            data: this.dashboardDepartment.emp.map((res: any) => res.qty),
            backgroundColor: ['#95A4FC'],
            borderRadius: 8,
            borderSkipped: false
          }]
        },
        options: {
          plugins: {
            legend: {
              display: false,
              position: 'top',
              labels: {
                usePointStyle: true,
              },
            },
            datalabels: {
              display: false,
              color: '#000',
              font: {
                size: 12,
                weight: "bold"
              },
              anchor: "end",
              align: "start",
              offset: -23
            },
          },
          layout: {
            padding: {
              bottom: 40
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: false,
                text: 'No. of Items'
              },
              border: {
                display: false,
              },
            }, x: {
              grid: {
                display: false,
              },
              border: {
                display: false,
              },
            }
          },
          responsive: true,
          maintainAspectRatio: false
        }
      });
        this.charts.push(employee);
      } else {
        console.warn('Canvas element not found: employee');
      }
    }
    if (this.brandData) {
      const _brandEl = this.brandCanvas && this.brandCanvas.nativeElement ? this.brandCanvas.nativeElement as HTMLCanvasElement : null;
      if (_brandEl) {
        const _existing = Chart.getChart(_brandEl as any);
        if (_existing) {
          try { _existing.destroy(); } catch (e) { console.warn('Error destroying existing brand chart', e); }
          const _i = this.charts.indexOf(_existing as any);
          if (_i > -1) { this.charts.splice(_i, 1); }
        }
        let brand = new Chart(_brandEl, {
        type: 'bar',
        data: {
          labels: this.dashboardDepartment?.brand?.map((res: any) => res?.brandDescr) ?? [],
          datasets: [{
            label: 'Brand',
            barThickness: 25,
            data: this.dashboardDepartment?.brand?.map((res: any) => res?.qty) ?? [],
            backgroundColor: ['#95A4FC'],
            borderRadius: 8,
            borderSkipped: false
          }]
        },
        options: {
          plugins: {
            legend: {
              display: false,
              labels: {
                usePointStyle: true,
              },
            },
            datalabels: {
              display: false,
              color: '#000',
              font: {
                size: 12,
                weight: "bold"
              },
              anchor: "end",
              align: "start",
              offset: -23
            },
          },
          layout: {
            padding: {
              bottom: 40
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: false,
                text: 'No. of Items'
              },
              border: {
                display: false,
              },
            },
            x: {
              grid: {
                display: false,
              },
              border: {
                display: false,
              },
            },
          },
          responsive: true,
          maintainAspectRatio: false
        }
      });

        this.charts.push(brand);
      } else {
        console.warn('Canvas element not found: brand');
      }
    }

    if (this.platformDeptData) {
      const _platformDeptEl = (this.platformdeptCanvas && this.platformdeptCanvas.nativeElement) ? this.platformdeptCanvas.nativeElement as HTMLCanvasElement : document.getElementById('platformdept') as HTMLCanvasElement | null;
      if (_platformDeptEl) {
        const _existing = Chart.getChart(_platformDeptEl as any);
        if (_existing) {
          try { _existing.destroy(); } catch (e) { console.warn('Error destroying existing platformDept chart', e); }
          const _i = this.charts.indexOf(_existing as any);
          if (_i > -1) { this.charts.splice(_i, 1); }
        }
        let platformDept = new Chart(_platformDeptEl, {
        type: 'bar',
        data: {
          labels: this.platformLabels.map((res: any) => res.departmentDescr),
          datasets: this.platformData.map((dataRow: number[], index) => ({
            data: dataRow,
            barThickness: 25,
            label: this.platformDeptLabels[index].location,
            backgroundColor: this.getRandomColor(index),
            borderRadius: {
              bottomLeft: index === 0 ? 8 : 0,
              bottomRight: index === 0 ? 8 : 0,
              topLeft: index === this.platformData.length - 1 ? 8 : 0,
              topRight: index === this.platformData.length - 1 ? 8 : 0
            },
          })),
        },
        options: {
          plugins: {
            legend: {
              display: false,
              position: 'top',
              labels: {
                usePointStyle: true,
              },
            },
            tooltip: {
              enabled: true,
            },
            datalabels: {
              display: false,
              color: '#000',
              font: {
                size: 12,
                weight: "bold"
              },
              anchor: "end",
              align: "start",
              offset: -23
            },
          },
          scales: {
            x: {
              stacked: true,
              grid: {
                display: false,
              },
              border: {
                display: false,
              },
            },
            y: {
              stacked: true,
              border: {
                display: false,
              },
            }
          },
          maintainAspectRatio: false,
          responsive: true
        }
      });
        this.charts.push(platformDept);
        this.platformChart = platformDept;
      } else {
        console.warn('Canvas element not found: platformdept');
      }
    }
    if (this.printData) {

      const _printEl = this.printCanvas && this.printCanvas.nativeElement ? this.printCanvas.nativeElement as HTMLCanvasElement : null;
      if (_printEl) {
        const _existing = Chart.getChart(_printEl as any);
        if (_existing) {
          try { _existing.destroy(); } catch (e) { console.warn('Error destroying existing print chart', e); }
          const _i = this.charts.indexOf(_existing as any);
          if (_i > -1) { this.charts.splice(_i, 1); }
        }
        let print = new Chart(_printEl, {
        type: 'bar',
        data: {
          labels: this.barChartLabels.map((res) => res.departmentDescr),
          datasets: this.barChartData.map((dataRow: number[], index) => ({
            data: dataRow,
            barThickness: 25,
            label: this.printLabels[index]?.formatTypeDesr ?? '',
            backgroundColor: this.getRandomColor(index),
            borderRadius: {
              bottomLeft: index == 0 ? 8 : 0,
              bottomRight: index == 0 ? 8 : 0,
              topLeft: index === this.barChartData.length - 1 ? 8 : 0,
              topRight: index === this.barChartData.length - 1 ? 8 : 0
            },
          })),
        },
        options: {
          plugins: {
            legend: {
              display: false,
              position: 'top',
              labels: {
                usePointStyle: true,
              },
            },
            datalabels: {
              display: false,
            },
          },
          scales: {
            x: {
              stacked: true,
              grid: {
                display: false,
              },
              border: {
                display: false,
              },
            },
            y: {
              stacked: true,
              border: {
                display: false,
              },
            },
          },
          maintainAspectRatio: false,
          responsive: true,
        },
      });
        this.charts.push(print);
      } else {
        console.warn('Canvas element not found: print');
      }
    }
    if (this.specialPriceData) {
      const _priceEl = this.priceCanvas && this.priceCanvas.nativeElement ? this.priceCanvas.nativeElement as HTMLCanvasElement : null;
      if (_priceEl) {
        const _existing = Chart.getChart(_priceEl as any);
        if (_existing) {
          try { _existing.destroy(); } catch (e) { console.warn('Error destroying existing price chart', e); }
          const _i = this.charts.indexOf(_existing as any);
          if (_i > -1) { this.charts.splice(_i, 1); }
        }
        this.priceChart = new Chart(_priceEl, {
        type: 'doughnut',
        data: {
          labels: this.dashboardDepartment.specialPrice.map((res: any) => res.departmentDescr),
          datasets: [{
            label: 'Item',
            data: this.dashboardDepartment.specialPrice.map((res: any) => res.qty),
            backgroundColor: this.dashboardDepartment.specialPrice.map((res: any, index: number) => this.getRandomColor(index)),
            borderRadius: 7,
            borderWidth: 3
          }]
        },
        options: {
          cutout: '60%',
          plugins: {
            legend: {
              display: true,
              position: 'right',
              labels: {
                usePointStyle: true,
              },
            },
            datalabels: {
              display: false,
            },
          },
          layout: {
            padding: {
              bottom: 0,
              top: 10,
              left: 0,
              right: 40
            }
          },
          scales: {
            x: {
              display: false,
            },
            y: {
              display: false,
            }
          },
          maintainAspectRatio: false,
          responsive: true
        }
      });
      } else {
        console.warn('Canvas element not found: price');
      }
    }


    this.isLoading = false;
  }

  getRandomColor(index: number) {
    /*   let colors = ['#95a4fc', '#9fadfd', '#a9b7fe', '#b3c0ff', '#bec9ff', '#c8d2ff', '#d3dbff', '#dee4ff','#e9edff']*/
    let color = "hsl(" + Math.random() * 360 + ", 100%, 75%)";
    return color;
  }

  async updateChart(val: number) {
    this.departmentId = val;
    if (this.isTableData) {
      await this.getDashboardTable();
    } else {
      await this.destroyCharts(val);
    }
  }

  async destroyCharts(val: number) {
    this.deptQty = 0;
    this.empQty = 0;
    this.brandQty = 0;
    this.formatQty = 0;
    this.specialPriceQty = 0;
    this.platformQty = 0;
    this.platformDepartmentQty = 0;
    this.totalQty = 0;
    this.totalPrice = 0;
    this.totalCatg = 0;
    this.printLabels = []
    this.platformData = []
    this.platformLabels = []
    this.platformDeptLabels = []
    this.charts.forEach((chart) => {
      if (chart) {
        chart.destroy();
      }
    });
    if (this.priceChart) {
      this.priceChart.destroy()
    }
    if (this.platformChart) {
      this.platformChart.destroy();
    }
    this.charts = [];
    await this.getDashboardDepartment(val);
  }
  
  ngOnDestroy(): void {
    try {
      this.charts.forEach((chart) => {
        if (chart) {
          chart.destroy();
        }
      });
      if (this.priceChart) {
        this.priceChart.destroy();
      }
      if (this.platformChart) {
        this.platformChart.destroy();
      }
    } catch (e) {
      console.warn('Error destroying charts on ngOnDestroy', e);
    }
    this.charts = [];
  }
  formateDashboardTableData(dashboardDetails: any[]): any[] {
    this.isLoading = true;
    return dashboardDetails.reduce((result, item) => {
      const departmentKey = item.departmentDescr;
      const categoryName = item.categoryName;
      const storeName = item.storeName;
      const catQty = item.deptQty;
      const userName = item.userName;

      // Initialize department if not exists
      const department = result.find((dep: { department: any; }) => dep.department === departmentKey);

      if (!department) {
        result.push({
          department: departmentKey,
          qty: [],
          categories: []
        });
      }

      // Find or create category
      const departmentIndex = result.findIndex((dep: { department: any; }) => dep.department === departmentKey);
      const category = result[departmentIndex].categories.find((cat: { cname: any; }) => cat.cname === categoryName);

      if (!category) {
        result[departmentIndex].categories.push({
          cname: categoryName,
          qty: []
        });
      }

      // Update quantity
      const categoryIndex = result[departmentIndex].categories.findIndex((cat: { cname: any; }) => cat.cname === categoryName);
      const storeIndex = result[departmentIndex].qty.findIndex((q: { userName: any; }) => q.userName === userName);

      if (storeIndex === -1) {
        result[departmentIndex].qty.push({ store: storeName, qty: catQty, userName: userName });
      } else {
        result[departmentIndex].qty[storeIndex].qty += catQty;
      }

      // Update category quantity
      result[departmentIndex].categories[categoryIndex].qty.push({
        store: storeName,
        qty: catQty,
        userName: userName
      });
      this.isLoading = false;
      return result;
    }, []);
  }
}
